export enum bookLikeActionsType {
  BOOK_LIKES_LOADED = "BOOK_LIKES_LOADED",
  BOOK_LIKES_FAILED = "BOOK_LIKES_FAILED",
  WORK_LIKES_LOADED = "WORK_LIKES_LOADED",
}
